//* 设备校验中间件
export default defineNuxtRouteMiddleware(() => {
    if (process.client) return;
    else {
        const website = useWebsiteStore();
        const isMobile = /Mobile|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(useRequestHeader("User-Agent") || "");

        if (isMobile) website.updated({ agent: "mobile" });
        else {
            website.updated({ agent: "web" });
        }
    }
});
